













import Vue from "vue";

import UserService from "@/services/user.service";
import Image from "@/assets/Image";
import ImageComponent from "@/components/images/Image.vue";

export default Vue.extend({
  components: {
    ImageComponent
  },

  data(): { images: Image[] } {
    return {
      images: []
    };
  },

  computed: {
    userId() {
      return this.$store.state.profil.user?.id;
    }
  },

  watch: {
    userId() {
      this.update();
    }
  },

  mounted() {
    this.update();
  },

  methods: {
    async update() {
      if (this.userId) {
        const response = await UserService.getUserImages(this.userId);
        this.images = response.data;
      }
    }
  }
});
